const getDefaultState = () => {
  return {
    id: null,
    scenario: null,
    energies: null,
    address: {
      street: null,
      number: null,
      box: null,
      floor: null,
      locality: null,
    },
    inhabitants: null,
    unoccupied: 0,
    unoccupiedType: 'soon',
    socialRate: 0,
    remark: null,
    deliveryDate: null,
    instalmentDaysDD: [6],
    instalmentDaysBT: 0,
    wantOnlineGreen: false,
    electricity: {
      eanKnown: 1,
      ean: null,
      contractType: null,
      green: 0,
      duration: null,
      previousProvider: null,
      asap: 0,
      deliveryDate: null,
      moveDate: null,
      openMeterDate: null,
      solarPanel: 0,
      solarPanelPower: null,
      solarPanelScenario: null,
      solarPanelNumber: null,
      solarPanelCertification: null,
      meter: {
        type: [],
        injection: 0,
        number: null,
        status: 'open',
        readingType: null,
        power: null,
      },
      index: {
        base: null,
        high: null,
        low: null,
        injectionBase: null,
        injectionHigh: null,
        injectionLow: null,
        exclusiveNight: null
      },
      consumption: {
        base: null,
        high: null,
        low: null,
        injectionBase: null,
        injectionHigh: null,
        injectionLow: null,
        exclusiveNight: null,
      },
      product: null,
    },
    gas: {
      eanKnown: 1,
      ean: null,
      contractType: null,
      green: 0,
      duration: null,
      previousProvider: null,
      asap: 0,
      deliveryDate: null,
      moveDate: null,
      openMeterDate: null,
      meter: {
        number: null,
        status: 'open',
        readingType: null,
      },
      index: null,
      consumption: null,
      product: null,
    },
    rates: {
      electricity: null,
      gas: null
    }
  }
}

export default{
  getDefaultState
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/default.js